import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import Textarea from "~/common/components/textarea";
import { AppContext } from "../../../RoundRegContext";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";

const InquiryAgree = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(AppContext);

	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	const handleDetailChange = (e) => {
		setListByTarget({ ...card, content: e.target.value });
	};

	const handleAgrrDetailChange = (e) => {
		setListByTarget({ ...card, agreeDescription: e.target.value });
	};

	return (
		<>
			<div className="c__form horiz">
				<div className="f__group export-label">
					<div className="f__control">
						<input
							name="inquiryAgree"
							className="c__input f__item"
							placeholder={t(
								"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.question"
							)}
							type="text"
							value={card.title}
							onChange={handleChange}
						></input>
					</div>
				</div>
				<div className="f__group">
					<div className="f__control">
						<textarea
							name="agreeContent"
							className="c__textarea f__item "
							placeholder={t(
								"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.input"
							)}
							value={card.content}
							onChange={handleDetailChange}
						></textarea>
					</div>
				</div>
				<div className="f__group ">
					<div className="f__control-wrap">
						<label className="checkbox-custom">
							<input type="checkbox"></input>
							<span className="checkmark"></span>
						</label>
						<div className="f__control export-input">
							<input
								name="inquiryAgreeChk"
								className="c__input f__item"
								placeholder={t(
									"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.privacyPolicy"
								)}
								type="text"
								value={card.agreeDescription}
								onChange={handleAgrrDetailChange}
							></input>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default InquiryAgree;
